'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _radium = require('radium');

var _radium2 = _interopRequireDefault(_radium);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function CarouselCard(_ref) {
  var backgroundColor = _ref.backgroundColor,
      height = _ref.height,
      width = _ref.width,
      border = _ref.border,
      cardContent = _ref.cardContent,
      additionalText = _ref.additionalText,
      cardFontFamily = _ref.cardFontFamily,
      cardFontWeight = _ref.cardFontWeight,
      cardFontSize = _ref.cardFontSize,
      cardColor = _ref.cardColor,
      textFontFamily = _ref.textFontFamily,
      textFontSize = _ref.textFontSize,
      textColor = _ref.textColor,
      textAlign = _ref.textAlign,
      textMargin = _ref.textMargin,
      alignItems = _ref.alignItems,
      justifyContent = _ref.justifyContent;

  function cardStyle() {
    return {
      display: 'flex',
      justifyContent: justifyContent || 'center',
      alignItems: alignItems || 'center',
      backgroundColor: backgroundColor || 'transparent',
      height: height || '135px',
      width: width || 'auto',
      border: border || '4px solid #eee',
      fontFamily: cardFontFamily || '"Gotham SSm A", "Gotham SSm B"',
      fontWeight: cardFontWeight || 700,
      fontSize: cardFontSize || '34px',
      color: cardColor || '#0096ff'
    };
  }

  function textStyle() {
    return {
      textAlign: textAlign || 'center',
      fontFamily: textFontFamily || 'Helvetica Neue',
      fontSize: textFontSize || '18px',
      color: textColor || '#4a494b',
      margin: textMargin || '30px 0 50px'
    };
  }

  return _react2["default"].createElement('div', null, _react2["default"].createElement('div', {
    style: cardStyle()
  }, cardContent), _react2["default"].createElement('div', {
    style: textStyle()
  }, additionalText));
}

var component = (0, _radium2["default"])(CarouselCard);
exports["default"] = {
  component: component
};